"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Selector = _interopRequireDefault(require("../../Common/Selector"));
var _Tag = _interopRequireDefault(require("../../Tags/Tag"));
var _excluded = ["tags", "value", "dark"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var tagPropTypes = _Tag["default"].propTypes;
var tagProp = tagPropTypes.tag;
var CLASS_NAME_PREFIX = _Selector["default"].CLASS_NAME_PREFIX;
var PLACEHOLDER = 'Все теги';
var StyledTag = (0, _styledComponents["default"])(_Tag["default"]).withConfig({
  displayName: "TicketFilterByTag__StyledTag",
  componentId: "sc-tmpd9n-0"
})(["color:#17181a;font-size:14px;"]);
var TicketFilterByTag = /*#__PURE__*/function (_React$PureComponent) {
  function TicketFilterByTag(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TicketFilterByTag);
    _this = _callSuper(this, TicketFilterByTag, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleRef = _this.handleRef.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TicketFilterByTag, _React$PureComponent);
  return (0, _createClass2["default"])(TicketFilterByTag, [{
    key: "handleChange",
    value: function handleChange(value) {
      var _this$props = this.props,
        name = _this$props.name,
        onChange = _this$props.onChange;
      var formatedValue = Array.isArray(value) ? value.map(function (v) {
        return v.value;
      }) : null;
      this.el.name = name;
      this.el.value = formatedValue;
      var event = new CustomEvent('change', {
        bubbles: true
      });
      this.el.dispatchEvent(event);
      onChange(event);
    }
  }, {
    key: "handleRef",
    value: function handleRef(ref) {
      this.el = _reactDom["default"].findDOMNode(ref);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        tags = _this$props2.tags,
        value = _this$props2.value,
        dark = _this$props2.dark,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      if ((0, _isEmpty2["default"])(tags)) {
        return null;
      }
      var formatedValue = null;
      if (Array.isArray(value)) {
        formatedValue = value.map(function (v) {
          return (0, _find2["default"])(tags, {
            value: v
          });
        });
      }
      return /*#__PURE__*/_react["default"].createElement(StyledSelector, (0, _extends2["default"])({}, props, {
        components: {
          MultiValueLabel: TicketFilterByTag.getMultiValueLabel
        },
        isMulti: true,
        dark: dark,
        isSearchable: true,
        onChange: this.handleChange,
        options: tags,
        placeholder: PLACEHOLDER,
        ref: this.handleRef,
        value: formatedValue
      }), function (_ref) {
        var label = _ref.label;
        return /*#__PURE__*/_react["default"].createElement(StyledTag, {
          tag: label
        });
      });
    }
  }], [{
    key: "getMultiValueLabel",
    value: function getMultiValueLabel(_ref2) {
      var data = _ref2.data,
        innerProps = _ref2.innerProps;
      var label = data.label;
      return /*#__PURE__*/_react["default"].createElement("div", innerProps, /*#__PURE__*/_react["default"].createElement(StyledTag, {
        tag: label
      }));
    }
  }]);
}(_react["default"].PureComponent);
var tagValueProp = _propTypes["default"].string;
TicketFilterByTag.propTypes = {
  className: _propTypes["default"].string,
  name: _propTypes["default"].string,
  dark: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  tags: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: tagProp.isRequired,
    value: tagValueProp.isRequired
  }).isRequired),
  value: _propTypes["default"].arrayOf(tagValueProp.isRequired)
};
TicketFilterByTag.defaultProps = {
  className: '',
  name: '',
  dark: false,
  onChange: Function.prototype,
  tags: null,
  value: null
};
var StyledSelector = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "TicketFilterByTag__StyledSelector",
  componentId: "sc-tmpd9n-1"
})(["", ""], function (_ref3) {
  var dark = _ref3.dark;
  return dark && "\n    border: 1px solid #e6e9ee;\n    box-sizing: border-box;\n    border-radius: 4px;\n    padding: 0 3px;\n\n    .".concat(CLASS_NAME_PREFIX, "__multi-value {\n      background: #f5f3f2;\n      border: none;\n    }\n\n    ").concat(CLASS_NAME_PREFIX, "__placeholder {\n      color: #919499;\n    }\n  ");
});
var _default = exports["default"] = TicketFilterByTag;